import React, { useEffect, useState } from "react";
import { BookUser, Phone, Mail, Home } from "lucide-react";
import http from "@/lib/http";
import { t } from "@/i18n";

export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/api/contacts").then(r => { setContacts(r.data); setLoading(false); });
  }, []);

  return (
    <div className="p-8 max-w-[1100px] mx-auto fade-in" data-testid="contacts-screen">
      <div className="mb-6">
        <div className="text-[13px] text-[var(--teal-700)] font-medium mb-2 uppercase tracking-[0.14em]">
          {t("nav.contacts")}
        </div>
        <h1 className="font-display text-[32px] leading-tight text-[var(--ink-900)]">
          {t("contacts.title")}
        </h1>
        <p className="text-[14px] text-[var(--ink-500)] mt-1">
          {t("contacts.sub", { count: contacts.length })}
        </p>
      </div>

      {loading ? (
        <div className="text-[var(--ink-500)] text-sm">{t("common.loading")}</div>
      ) : contacts.length === 0 ? (
        <div className="card text-center py-16" data-testid="contacts-empty">
          <div className="w-14 h-14 mx-auto rounded-xl bg-[var(--teal-50)] text-[var(--teal-700)] grid place-items-center mb-4">
            <BookUser size={22} />
          </div>
          <h3 className="font-display text-[20px]">{t("contacts.empty_title")}</h3>
          <p className="text-[14px] text-[var(--ink-500)] mt-2 max-w-md mx-auto">{t("contacts.empty_body")}</p>
        </div>
      ) : (
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="contacts-list">
          {contacts.map(c => (
            <li key={c.id} className="card" data-testid={`contact-card-${c.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="font-display text-[18px] leading-tight text-[var(--ink-900)]">{c.name}</div>
                  <span className={`chip ${c.role === "agent" ? "chip-teal" : ""} mt-2`}>
                    {t(`contacts.role_${c.role}`)}
                  </span>
                </div>
              </div>
              <div className="space-y-1.5 text-[13px] text-[var(--ink-700)] mb-4">
                {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-2 hover:text-[var(--teal-600)]"><Phone size={13} /> {c.phone}</a>}
                {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-2 hover:text-[var(--teal-600)]"><Mail size={13} /> {c.email}</a>}
              </div>
              <div>
                <div className="text-[11px] uppercase tracking-wider text-[var(--ink-500)] mb-2">
                  {t("contacts.linked_properties")}
                </div>
                <ul className="space-y-1">
                  {c.linked_leads.map(l => (
                    <li key={l.id} className="flex items-center gap-2 text-[12px] text-[var(--ink-700)]">
                      <Home size={12} className="text-[var(--ink-400)]" />
                      {l.address}, {l.postal_code} {l.city}
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
